import { createRoute } from '@tanstack/react-router'
import { Login } from '@/pages/Login'
import { Route as rootRoute } from './__root'

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: Login,
})
